import { gql, useLazyQuery } from "@apollo/client"
import { BenefitsReconciliationRun } from "@oysterhr/schema"

const SINGLE_RECONCILIATION_QUERY = gql`
  query BenefitsStaffReconciliationRunStatus($id: ID!) {
    benefitReconciliationRun(benefitsReconciliationRunId: $id) {
      id
      status
      createdAt
      provider {
        id
      }
      output {
        url
        title
        createdAt
      }
    }
  }
`

export function useReconciliationRun() {
  return useLazyQuery<{ benefitReconciliationRun: BenefitsReconciliationRun }, { id: string }>(
    SINGLE_RECONCILIATION_QUERY,
    {
      fetchPolicy: "network-only",
    },
  )
}
